import { updateKeyInStore } from 'App';
import {
  TDidYourEmployerProvideAnAllowanceOnTopOfDirectSalaryListRow,
  TForeignEmployerRow,
  updateKey,
  WagesStateValues,
} from '../slice';

export const uploadFields: IBaseField<
  | keyof WagesStateValues
  | keyof TForeignEmployerRow
  | keyof TDidYourEmployerProvideAnAllowanceOnTopOfDirectSalaryListRow
>[] = [
  {
    name: 'pleaseUploadFormW2',
    label: 'Please upload Form W2',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.didYouEarnWagesFromAUsEmployer',
  },
  {
    name: 'uploadAnnualNonUsWageStatementFromForeignEmployers',
    label: 'Upload annual non-US wage statement from foreign employers',
    subLabel: () => <p>T4, Certificat de Salaire, PAYE, etc.</p>,
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.incomeOutsideOfTheUs',
  },
  {
    name: 'didYouReceiveStockBasedCompensationFromYourEmployer',
    label: 'Did you receive stock-based compensation from your employer?',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.incomeOutsideOfTheUs',
  },
  {
    name: 'pleaseUploadSupportingDocumentation',
    label: 'Please upload supporting documentation',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.didYouReceiveStockBasedCompensationFromYourEmployer',
  },
  {
    name: 'pleaseUploadFormW2',
    label: 'Please upload Form W-2',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.didYouReceiveWagesDuringTheYearFromAUsEmployer',
  },
  {
    name: 'areYouAUsGovernmentEmployee',
    label: 'Are you a US government employee?',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.didYouReceiveWagesDuringTheYearFromAUsEmployer',
  },
  {
    name: 'didYouPerformWorkAsAConsultantOrIndependentContractorForAUsFirm',
    label:
      'Did you perform work as a consultant or independent contractor for a US firm?',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.incomeOutsideOfTheUs',
  },
  {
    name: 'pleaseUploadForm1099Misc',
    label: 'Please upload Form 1099-MISC',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.didYouPerformWorkAsAConsultantOrIndependentContractorForAUsFirm',
  },
  {
    name: 'didYouReceiveRoyaltiesUnemploymentPaymentsOrOtherMiscellaneousIncomeFromAUsSource',
    label:
      'Did you receive royalties, unemployment payments or other miscellaneous income from a US source?',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.incomeOutsideOfTheUs',
  },
  {
    name: 'pleaseUploadACopyOfForm1099MiscOrFormK1',
    label: 'Please upload a copy of form 1099-MISC or Form K-1',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.wages.values.didYouReceiveRoyaltiesUnemploymentPaymentsOrOtherMiscellaneousIncomeFromAUsSource',
  },
];
